/* eslint-disable @typescript-eslint/no-explicit-any */
import { ConfigProvider, Dropdown, Flex, Layout, MenuProps, Skeleton, Typography } from 'antd';
import SiderBox from './Sider';
import { DownOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getSelectedTemplateId, getUserInfo, getUserToken } from '../reducers/User/actions';
import api from '../utils/api';
import { resetUser, setSelectedTemplateId } from '../reducers/User/reducer';
import { useEffect, useState } from 'react';
import BrandLogo from './BrandLogo';

const { Content, Header } = Layout;
const { Text } = Typography;

interface LayoutProps {
  children: React.ReactNode;
}

const AppLayout: React.FC<LayoutProps> = ({ children }) => {
  const userInfo: any = useSelector(getUserInfo);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isPageLoading, setPageLoading] = useState(false);
  const globalSelectedTemplate = useSelector(getSelectedTemplateId);

  const headerStyle: React.CSSProperties = {
    height: 62,
    paddingLeft: 16,
    paddingRight: 36,
    lineHeight: '64px',
    backgroundColor: '#181818',
    paddingTop: 16,
    paddingBottom: 16,
  };

  const contentStyle: React.CSSProperties = {
    padding: 24,
    maxHeight: '100%',
    overflowY: 'auto',
    backgroundColor: '#FFF',
  };

  // useEffect(() => {
  //   getAllAuditTemplates();
  // }, []);

  // const getAllAuditTemplates = () => {
  //   setPageLoading(true);
  //   api
  //     .post('/insights/audit-templates', {})
  //     .then(() => {
  //       setPageLoading(false);
  //     })
  //     .catch((error: any) => {
  //       setPageLoading(false);
  //       console.log(error);
  //     });
  // };

  const handleLogOut = () => {
    const tokenDetails: any = getUserToken();
    api
      .post(
        '/auth/logout',
        { refresh_token: tokenDetails?.refresh || '' },
        {
          headers: {
            Authorization: `Bearer ${tokenDetails?.access_token}`,
          },
        },
      )
      .then(() => {
        dispatch(resetUser());
        navigate('/login');
      })
      .catch(() => {
        console.log('Error logging out');
      });
  };

  const items: MenuProps['items'] = [
    {
      key: '1',
      label: <a onClick={() => handleLogOut()}>Logout</a>,
    },
  ];

  return (
    <Layout style={{ height: '100%' }}>
      <Header style={headerStyle}>
        <Flex justify="space-between" align="center" style={{ height: '100%' }}>
          <BrandLogo logosrc="/assets/logo-text.svg" />
          <Dropdown menu={{ items }} placement="bottomRight" arrow trigger={['click']}>
            <Flex gap={8} align="center" style={{ cursor: 'pointer', marginRight: 12 }}>
              <img src="/assets/user.svg" />
              <Flex vertical>
                <ConfigProvider
                  theme={{
                    components: {
                      Typography: {
                        fontWeightStrong: 700,
                        colorText: '#fff',
                        lineHeight: 1.3,
                      },
                    },
                  }}
                >
                  <Text strong style={{ color: '#FFFFFF' }}>
                    {userInfo?.name
                      ? userInfo.name
                          .split('@')[0]
                          .split('.')
                          .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
                          .join(' ')
                      : 'User'}
                  </Text>
                  <Text style={{ fontSize: 12, color: '#D3D3D3' }}>{userInfo?.role}</Text>
                </ConfigProvider>
              </Flex>
              <DownOutlined style={{ fontSize: 18, color: '#FFFFFFE0' }} />
            </Flex>
          </Dropdown>
        </Flex>
      </Header>
      <Layout>
        <SiderBox />
        <ConfigProvider
          theme={{
            components: {
              Layout: {
                bodyBg: '#fff',
              },
            },
          }}
        >
          <Layout>{isPageLoading ? <Skeleton active /> : <Content style={contentStyle}>{children}</Content>}</Layout>
        </ConfigProvider>
      </Layout>
    </Layout>
  );
};

export default AppLayout;
